import React from 'react';
import { useUI } from '../UIContext';

export default function ActionConfirmModal({
  open,
  title = 'Confirm Action',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  danger = false,
  hideCancel = false,
}) {
  const { textStyle, cardStyle } = useUI();

  if (!open) return null;

  return (
    <div className="action-confirm-overlay">
      <div
        className="action-confirm-card"
        style={{
          ...cardStyle,
          background: 'var(--card-bg, #fff)',
          color: 'var(--text-color, #000)',
        }}
      >
        <h3 className="action-confirm-title" style={{ marginBottom: '12px' }}>{title}</h3>
        <p style={{ ...textStyle, marginBottom: '24px' }}>{message}</p>
        <div className="action-confirm-actions">
          {!hideCancel && (
            <button
              onClick={onCancel}
              className="btn-subtle action-confirm-cancel"
            >
              {cancelLabel}
            </button>
          )}
          <button
            onClick={onConfirm}
            className={`btn-subtle ${danger ? 'action-confirm-danger' : 'action-confirm-primary'}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
